<template>
    <div :class="{'form-group':true, 'has-errors': fieldErrors }">
        <label v-if="label" :for="id" v-html="label"></label>

        <div class="ninja-input">
            <textarea v-if="type === 'textarea'"
                      ref="input"
                      :id="id"
                      :name="name"
                      v-model="value"
                      :placeholder="placeholder"
                      :required="required"
                      @input="handleInput"
                      @keydown="handleKeyDown"
                      @blur="handleBlur"
                      @focus="handleFocus"
                      class="form-control"></textarea>

            <input v-if="type !== 'textarea'"
                   ref="input"
                   :id="id"
                   :name="name"
                   :type="type"
                   :value="value"
                   :placeholder="placeholder"
                   :required="required"
                   :disabled="disabled"
                   @input="handleInput"
                   @keydown="handleKeyDown"
                   @blur="handleBlur"
                   @focus="handleFocus"
                   class="form-control">
            <div class="ninja-bars">
                <div class="ninja-bar ninja-focus"></div>
                <div class="ninja-bar ninja-error"></div>
            </div>
        </div>

        <ul class="form-errors" v-if="fieldErrors">
            <li v-for="(error, index) in fieldErrors" :key="index">{{ error }}</li>
        </ul>
    </div>
</template>

<script>
    import VuexTextMixin from "vuex-forms/lib/mixins/vuex-text"
    export default {
        name: 'FormText',
        mixins: [VuexTextMixin()]
    }
</script>


// WEBPACK FOOTER //
// FormText.vue?4f10c104